

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { axios } from '../contexts/AuthContext';

export default function BoothStats() {
  const navigate = useNavigate();
  const [booths, setBooths] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios.get('/stats/booths').then(r => setBooths(r.data)).catch(()=>{}).finally(() => setLoading(false));
  }, []);

  const filtered = booths.filter(b =>
    !search || b.booth_number?.toString().includes(search) ||
    b.booth_address?.toLowerCase().includes(search.toLowerCase()) ||
    b.area?.toLowerCase().includes(search.toLowerCase())
  );
  const totalVoters = booths.reduce((s,b) => s+(parseInt(b.total)||0), 0);

  if (loading) return <div className="loader"><div className="spinner"/><p style={{fontFamily:"'Outfit',sans-serif",color:'#FF6B00'}}>Loading booths...</p></div>;

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(160deg,#FFF4ED,#FFF8F0)',fontFamily:"'Outfit',sans-serif"}}>

      {/* Header */}
      <div className="app-header">
        <div style={{display:'flex',alignItems:'center',gap:10}}>
          <button className="back-btn" onClick={() => navigate('/')}>←</button>
          <div>
            <div style={{fontFamily:"'Baloo 2',sans-serif",fontWeight:700,fontSize:'1.1rem',color:'white'}}>Booth Statistics</div>
            <div style={{fontSize:'0.7rem',opacity:.8,color:'white'}}>{booths.length} Booths • {totalVoters.toLocaleString()} Voters</div>
          </div>
        </div>
      </div>

      <div style={{maxWidth:1000,margin:'0 auto',padding:'24px'}}>

        {/* Summary Cards */}
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(160px,1fr))',gap:14,marginBottom:24}} className="stagger">
          {[
            {label:'Total Booths',  value:booths.length,          img:'/images/Booth-statistics.png', icon:'🏫', color:'#FF6B00', bg:'linear-gradient(135deg,#FFF3E0,#FFE0B2)'},
            {label:'Total Voters',  value:totalVoters.toLocaleString(), img:'/images/total-voters.png', icon:'👥', color:'#1565C0', bg:'linear-gradient(135deg,#E3F2FD,#BBDEFB)'},
            {label:'Male Voters',   value:booths.reduce((s,b)=>s+(parseInt(b.male)||0),0).toLocaleString(),   img:'/images/male.png',         icon:'👨', color:'#1565C0', bg:'linear-gradient(135deg,#E3F2FD,#BBDEFB)'},
            {label:'Female Voters', value:booths.reduce((s,b)=>s+(parseInt(b.female)||0),0).toLocaleString(), img:'/images/female.png',       icon:'👩', color:'#880E4F', bg:'linear-gradient(135deg,#FCE4EC,#F8BBD0)'},
          ].map(s=>(
            <div key={s.label} style={{background:s.bg,borderRadius:16,padding:'18px 14px',textAlign:'center',boxShadow:'0 4px 16px rgba(255,107,0,0.1)',border:'1px solid rgba(255,255,255,0.7)',transition:'all 0.3s',cursor:'default'}}
              onMouseEnter={e=>{e.currentTarget.style.transform='translateY(-4px)';e.currentTarget.style.boxShadow='0 12px 32px rgba(255,107,0,0.2)';}}
              onMouseLeave={e=>{e.currentTarget.style.transform='none';e.currentTarget.style.boxShadow='0 4px 16px rgba(255,107,0,0.1)';}}>
              <div style={{width:56,height:56,borderRadius:14,background:'rgba(255,255,255,0.6)',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 8px',overflow:'hidden'}}>
                <img src={s.img} alt={s.label} style={{width:'82%',height:'82%',objectFit:'contain'}} onError={e=>{e.target.style.display='none';e.target.parentElement.innerHTML=`<span style="font-size:1.8rem">${s.icon}</span>`;}}/>
              </div>
              <div style={{fontFamily:"'Baloo 2',sans-serif",fontWeight:800,fontSize:'1.4rem',color:s.color}}>{s.value}</div>
              <div style={{fontSize:'0.72rem',color:'#666',fontWeight:600,marginTop:2}}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* Search */}
        <div style={{position:'relative',marginBottom:20}}>
          <span style={{position:'absolute',left:16,top:'50%',transform:'translateY(-50%)',fontSize:'1.1rem',color:'#FF6B00'}}>🔍</span>
          <input style={{
            width:'100%',padding:'13px 16px 13px 46px',
            border:'2px solid rgba(255,107,0,0.2)',borderRadius:14,
            fontSize:'0.9rem',fontFamily:"'Outfit',sans-serif",
            background:'rgba(255,255,255,0.85)',backdropFilter:'blur(10px)',
            outline:'none',transition:'all 0.25s',
          }}
          placeholder="Search booth number, name or area..."
          value={search} onChange={e => setSearch(e.target.value)}
          onFocus={e=>{e.target.style.borderColor='#FF6B00';e.target.style.boxShadow='0 0 0 4px rgba(255,107,0,0.1)';e.target.style.background='white';}}
          onBlur={e=>{e.target.style.borderColor='rgba(255,107,0,0.2)';e.target.style.boxShadow='none';e.target.style.background='rgba(255,255,255,0.85)';}}/>
        </div>

        {/* Column Header */}
        <div style={{
          display:'grid',gridTemplateColumns:'60px 1fr auto',gap:12,
          padding:'10px 18px',
          background:'linear-gradient(135deg,#E55100,#FF6B00)',
          borderRadius:12,marginBottom:10,
          color:'white',fontSize:'0.75rem',fontWeight:700,letterSpacing:'0.5px',
        }}>
          <span>BOOTH</span><span>BOOTH NAME / AREA</span><span>M / F / O | TOTAL</span>
        </div>

        {/* Booth Cards */}
        <div className="stagger">
          {filtered.map((booth, idx) => {
            const mPct = booth.total ? ((booth.male||0)/booth.total)*100 : 0;
            const fPct = booth.total ? ((booth.female||0)/booth.total)*100 : 0;
            return (
              <div key={`${booth.booth_number}-${idx}`}
                onClick={() => navigate(`/booths/${booth.booth_number}`)}
                style={{
                  background:'rgba(255,255,255,0.88)',
                  backdropFilter:'blur(12px)',
                  borderRadius:16,marginBottom:10,
                  border:'1px solid rgba(255,255,255,0.7)',
                  boxShadow:'0 3px 16px rgba(255,107,0,0.07)',
                  cursor:'pointer', overflow:'hidden',
                  transition:'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                }}
                onMouseEnter={e=>{e.currentTarget.style.transform='translateX(6px) translateY(-2px)';e.currentTarget.style.boxShadow='0 10px 36px rgba(255,107,0,0.2)';e.currentTarget.style.borderColor='rgba(255,107,0,0.3)';}}
                onMouseLeave={e=>{e.currentTarget.style.transform='none';e.currentTarget.style.boxShadow='0 3px 16px rgba(255,107,0,0.07)';e.currentTarget.style.borderColor='rgba(255,255,255,0.7)';}}
              >
                <div style={{display:'grid',gridTemplateColumns:'60px 1fr auto',gap:12,alignItems:'center',padding:'14px 18px'}}>
                  <div style={{
                    width:44,height:44,borderRadius:'50%',
                    background:'linear-gradient(135deg,#FFF3E0,#FFE0B2)',
                    border:'2px solid rgba(255,107,0,0.2)',
                    display:'flex',alignItems:'center',justifyContent:'center',
                    fontFamily:"'Baloo 2',sans-serif",fontWeight:800,fontSize:'0.95rem',color:'#E55100',
                  }}>{booth.booth_number}</div>
                  <div>
                    <div style={{fontWeight:700,fontSize:'0.88rem',marginBottom:2,color:'#1A0A00'}}>{booth.booth_address?booth.booth_address.substring(0,50):`Booth ${booth.booth_number}`}</div>
                    {booth.area && <div style={{fontSize:'0.74rem',color:'#9E6040'}}>📍 {booth.area}</div>}
                  </div>
                  <div style={{textAlign:'right',flexShrink:0}}>
                    <div style={{fontFamily:"'Baloo 2',sans-serif",fontWeight:800,fontSize:'1.1rem',color:'#E55100'}}>{(booth.total||0).toLocaleString()}</div>
                    <div style={{fontSize:'0.7rem',color:'#9E6040',marginTop:1}}>{booth.male||0}M / {booth.female||0}F</div>
                  </div>
                </div>
                {/* Progress bar */}
                <div style={{height:5,background:'#F5F5F5',display:'flex',overflow:'hidden'}}>
                  <div style={{width:`${mPct}%`,background:'#1565C0',transition:'width 1s ease'}}/>
                  <div style={{width:`${fPct}%`,background:'#E91E63',transition:'width 1s ease'}}/>
                  <div style={{flex:1,background:'#FF9800'}}/>
                </div>
              </div>
            );
          })}
        </div>

        {filtered.length === 0 && <div className="empty-state"><h3>No booths found</h3></div>}
      </div>
    </div>
  );
}